import { GET_ORDER_INFO } from '../actionTypes/CartActionTypes';

export default function OrderInfoReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_INFO:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
